<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-xs-12 p-x-0 m-b-10 flex align-center">
        <router-link :to="{
          name: goBackInfo.name,
          params: goBackInfo.params,
          query: goBackInfo.query
        }">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div class="box-body">
            <ul class="nav nav-tabs mb-3">
              <li role="presentation" :class="{'active': tab == 2}" @click="updateQuery(2)">
                <a>配料</a>
              </li>
              <li role="presentation" :class="{'active': tab == 20}" @click="updateQuery(20)">
                <a>配料群組</a>
              </li>
              <li role="presentation" :class="{'active': tab == 10}" @click="updateQuery(10)">
                <a>商品分類</a>
              </li>
              <li role="presentation" :class="{'active': tab == 1}" @click="updateQuery(1)">
                <a>商品</a>
              </li>
              <li role="presentation" :class="{'active': tab == 11}" @click="updateQuery(11)">
                <a>品項選擇區</a>
              </li>
              <li role="presentation" :class="{'active': tab == 3}" @click="updateQuery(3)">
                <a>套餐</a>
              </li>
            </ul>
            <div class="row form-inline">
              <!-- skey sInput 用於搜尋使用、 sPage 紀錄頁數、isDeleteStatus 紀錄刪除狀態、selectAll 紀錄全選狀態-->
              <nd-binding-table
                :bindList="bindList"
                :bindMeta="bindMeta"
                :tab="tab"
                :skey="skey"
                :input="input"
                :sPage="sPage"
                :getBindingList="getBindingList"
                :selectAll="selectAll"
                :isDeleteStatus="isDeleteStatus"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import NdBindingTable from './Temp/BindingTable.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'nd-binding-pos',
  extends: NdExtendHandleMenu,
  components: {
    'nd-binding-table': NdBindingTable
  },
  data () {
    return {
      storeName: '',
      name: '迷客夏',
      total: 1,
      count: 20,
      groupAmount: 10,
      scheduleList: [],
      // tab 選擇
      tab: 2,
      bindList: [],
      bindMeta: {
        total: 0,
        size: 20
      },
      page: 1,
      selectAll: false,
      isDeleteStatus: false,
      skey: '',
      input: '',
      sPage: 1
    }
  },
  methods: {
    getBindingList (page, searchKey, searchInput) {
      this.selectAll = false
      this.isDeleteStatus = false
      let queryValue = {}

      if (page) {
        this.page = page
        queryValue = {
          ...queryValue,
          page: this.page
        }
      }

      let url = this.base + this.id + '/itemBinding/list?size=' + this.count + '&type=' + this.tab + '&page=' + this.page

      queryValue = {
        ...queryValue,
        tab: this.tab
      }

      if (searchInput) {
        queryValue = {
          ...queryValue,
          searchKey,
          searchInput
        }
        url += '&' + searchKey + '=' + searchInput
      }

      this.$router.replace({
        query: queryValue
      })

      this.getDataH('get', url, null, (response) => {
        this.bindList = response.data.list
        this.bindMeta = response.data.meta
      })
    },
    updateQuery (tab) {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: tab
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getStoreId']),
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        // console.log(oldList[key].menu_id)
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        })
      }
      return menuList
    },
    getDataH () {
      return this.$parent.getDataH
    }
  },
  watch: {
    tab () {
      var sKey = this.$route.query.searchKey
      var sInput = this.$route.query.searchInput
      var sPage = this.$route.query.page
      if (sKey && sInput) {
        this.skey = sKey
        this.input = sInput
        this.getBindingList(sPage, sKey, sInput)
      } else {
        this.getBindingList(1)
      }
    },
    '$route.query.tab' () {
      var defaultTab = this.$route.query.tab
      if (defaultTab) this.tab = parseInt(defaultTab, 10)
    }
  },
  created () {
    var defaultTab = this.$route.query.tab
    var sKey = this.$route.query.searchKey
    var sInput = this.$route.query.searchInput
    var sPage = this.$route.query.page
    if (defaultTab) this.tab = parseInt(defaultTab, 10)
    // 搜尋參數帶入
    if (sKey && sInput) {
      this.skey = sKey
      this.input = sInput
      if (sPage) {
        this.sPage = sPage
        this.getBindingList(sPage, sKey, sInput)
      } else {
        this.getBindingList(1, sKey, sInput)
      }
    } else {
      this.getBindingList(1)
    }
  },
  mounted () {
    this.getExtendHandleMenuInfo()
  }
}
</script>

<style lang="sass">
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>



// WEBPACK FOOTER //
// binding-pos.vue?14904810